import EnhancedDataGrid from "./EnhancedDataGrid";
import * as React from 'react';

export default function ServerExportWrapper(props) {

	const [isReadyForExport, setIsReadyForExport] = React.useState(false);

	const setForExport = () => {
		if (!isReadyForExport) {
			if (tempGridRef.current.getRowsCount() === props.rows.length) {
				setIsReadyForExport(true);
			}
		}

	}

	React.useEffect(() => {
		if (tempGridRef.current && props.dataLoaded) {
			let interval = setInterval(setForExport, 100);
			return () => {
				clearInterval(interval);
			};
		}
	}, [tempGridRef, props.dataLoaded])

	React.useEffect(() => {
		if (isReadyForExport) {
			tempGridRef.current.exportDataAsCsv(
				{
					fileName: props.options.exportFileName,
				}
			);
			let timeOut = setTimeout(props.resetStates, 1000);
			return () => {
				clearTimeout(timeOut);
			};
		}

	}, [isReadyForExport])

	const tempGridRef = React.useRef(null);
	return (
		<div style={{ display: 'none' }}>
			<EnhancedDataGrid
				{...props}
				filterMode={'server'}
				gridRef={tempGridRef}
			/>
		</div>
	);
}